export const homeStyles = () => ({
    root: {
        margin: '0',
        padding: '0',
        backgroundColor: '#0B1432',
        boxSizing: 'border-box',
        width: '100%',
        minHeight: '100vh',
        color: 'white'
    },
    body: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginX: { xs: "0%", sm: "10%" },
        // minHeight: '100vh',
    }
  });
  